import React, { useState, useEffect } from "react";
import { Button, Drawer } from "antd";
import {
  updateDisplayRoomDrawer,
  updateRoomPriceStructure,
  updatetaxIncludedInPriceLocalState,
  updateDisplayDetailedBreakupModal,
  updateShowRoomNumberModal,
  updateChangeDateBoolean,
  updateRoomRateEditable,
} from "../../../reducer/bookingReducer";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import CustomCalendar from "../components/EditRoom/CustomCalendar/CustomCalendar";
import EditRoomDetails from "../components/EditRoom/EditRoomDetails";
import { Switch } from "antd";
import GuestDropDown from "../components/EditRoom/GuestDropDown";
import { mealPlanChangeCalculation } from "../../../utils/bookingHelper";
import useBookingCalculation from "../../../hooks/bookingCustomHook/useBookingCalculation";
import { bookingDetailsDrawerWidth } from "../../../utils/bookingDetailsHelper";
import useEditBookingLogic from "../../../hooks/bookingCustomHook/useEditRoomLogic";
import { IoIosArrowRoundBack } from "react-icons/io";
import { BsInfoCircleFill } from "react-icons/bs";
import DetailedBreakupModal from "../Modal/DetailedBreakupModal";
import MealPlanDropDown from "../components/MealPlanDropDown";
import Room from "../Modal/Room";
import {
  resetState,
  updateDataChanged,
  updateShowNightAuditDrawer,
} from "../../../reducer/nightAuditReducer";
import ComplimentaryBookingsButton from "../components/complimentaryRooms/ComplimentaryRoomsButton";
import MarkComplimentaryRoomsDrawer from "../components/complimentaryRooms/ComplimentaryRoomsDrawer";

const RoomDrawer = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {
    hotelDetails,
    occupancyPlanRate,
    occupancyPlanRateLoading,
    occupancyPlanRateError,
    isAllHotelsSelected,
  } = useSelector((store) => store.login);

  const { dataChanged } = useSelector((store) => store.nightAudit);

  const {
    displayRoomDrawer,
    mealPlan,
    roomPriceStructure,
    selectedRoomWTypeAndNum,
    taxIncludedInPriceLocalState,
  } = useSelector((store) => store.booking);

  const roomTypes = hotelDetails?.roomTypes ? hotelDetails?.roomTypes : [];

  const [rooms, setRooms] = useState([]);
  const [calculationResult, setCalculationResult] = useState({});
  const [roomCountMap, setRoomCountMap] = useState({});

  const [mealPlanChanged, setMealPlanChanged] = useState(false);

  const handleClose = () => {
    dispatch(updateRoomRateEditable(false));
    dispatch(updateDisplayRoomDrawer());
    dispatch(updateChangeDateBoolean(false));
    setMealPlanChanged(false);

    // dispatch(updateShowNightAuditDrawer(true));
    // dispatch(resetState());
    // dispatch(updateDataChanged(!dataChanged));
  };

  useEffect(() => {
    let tempRooms = [];
    for (let key in selectedRoomWTypeAndNum) {
      selectedRoomWTypeAndNum[key]?.forEach((Obj) => {
        tempRooms.push(Obj.name);
      });
    }
    
    setRooms(tempRooms);
  }, [selectedRoomWTypeAndNum]);

  useEffect(() => {
    if (
      !displayRoomDrawer ||
      !Array.isArray(roomPriceStructure) ||
      !mealPlanChanged
    ) {
      return;
    }

    const currentRoomPriceStructure = mealPlanChangeCalculation(
      roomPriceStructure,
      roomTypes,
      mealPlan,
      occupancyPlanRate
    );
    
    dispatch(updateRoomPriceStructure(currentRoomPriceStructure));
  }, [mealPlan]);

  
  const { handleEditRoom } = useEditBookingLogic(
    setLoading,
    roomCountMap,
    calculationResult
  );
  

  useBookingCalculation(setCalculationResult, setRoomCountMap);
  
  

  return (
    <Drawer
      headerStyle={{ padding: 0 }}
      title={
        <div className="bg-surface-muted p-2 pl-4 border-b-[1px] border-surface-muted flex items-center gap-3 w-[70%]">
          <IoIosArrowRoundBack
            className="text-[24px] text-fg"
            onClick={() => {
              handleClose();
            }}
          />
          <span className="font-body font-[500] text-[18px] leading-[27px] text-fg">
            Extend/Date Changes
          </span>
        </div>
      }
      closable={false}
      onClose={handleClose}
      open={displayRoomDrawer}
      width={bookingDetailsDrawerWidth}
    >
      <div className=" fixed right-[2rem] w-[750px] top-[3rem]  flex  justify-around items-center gap-3 mt-[10px]">
        <CustomCalendar />

        <MealPlanDropDown setMealPlanChanged={setMealPlanChanged} />

        <GuestDropDown />
      </div>

      <Room />

      <EditRoomDetails mealPlanChanged={mealPlanChanged} />

      {loading ? (
        <div
          className=" py-4  
          border-t-[1px] border-brand-border-muted uppercase absolute  right-0 bottom-0 flex 
          justify-end  w-[100%] px-4"
        >
          <Button className="text-fg-inverse py-2   bg-primary" disabled={true}>
            <CircularProgress size={16} color="inherit" />
          </Button>
        </div>
      ) : (
        <div className=" absolute  right-[-1px] bottom-[-1px] flex flex-col gap-2 w-[100%] ">
          <div className="w-[100%]  flex justify-between items-center pl-[10px] ">
            <div className="font-body font-[500]   text-[16px] leading-[24px] text-fg w-[40%]">
              Selected Rooms -
            </div>

            <div className="flex flex-nowrap gap-2    items-center w-[30%]  justify-center">
              {rooms?.slice(0, 6)?.map((room) => (
                <div
                  key={room}
                  className="border-0 font-body text-[12px] font-[400] 
              leading-[18px]  p-[0.625rem] rounded-[0.1875rem] bg-warning-light cursor-default whitespace-nowrap h-[1.375rem]  flex justify-center items-center text-fg "
                >
                  {room}
                </div>
              ))}
            </div>

            <div className="w-[30%] flex gap-[px] items-center justify-end ">
              <span
                style={{ boxShadow: "-4px 0px 4px -3px rgba(0, 0, 0, 0.1)" }}
                className="font-body font-[400] text-[12px] leading-[18px] pr-[10px] text-primary cursor-pointer"
                onClick={() => {
                  dispatch(updateShowRoomNumberModal());
                }}
              >
                Edit/View
              </span>
            </div>
          </div>
          <div
            className="  flex flex-col gap-2 w-[100%] items-center text-[1.125rem] font-[600]
         border border-t-overlay-hover rounded-t-lg border-l-0"
          >
            <div className="flex justify-between  w-[100%] px-[1rem]">
              <div className="flex gap-2   items-center  flex-wrap w-[100%]">
                <label className="font-medium  leading-[21px] text-[10px] md:text-[12px] lg-[text-[14px]">
                  {" "}
                  Price Incl. Taxes
                </label>

                <Switch
                  size="small"
                  className="bg-overlay-active "
                  checked={Boolean(taxIncludedInPriceLocalState)}
                  onChange={(e) => {
                    const newValue = Boolean(taxIncludedInPriceLocalState) ? false : true;
                    dispatch(
                      updatetaxIncludedInPriceLocalState(newValue)
                    );
                  }}
                />
              </div>
              {occupancyPlanRateError ? (
                <div className="font-body font-[500] text-[red] text-[12px] flex  justify-center items-center ">
                  There seems to be an issue with the server. &nbsp; Please try
                  refreshing the page. If the problem continues, please contact
                  Revivo
                </div>
              ) : (
                <div className="w-[100%] font-body  flex justify-end gap-6  pt-2 shadow-mobile-footer">
                  <div className="flex flex-col items-start">
                    <div className="flex flex-col items-start cursor-pointer">
                      <div className="flex gap-1 items-center">
                        <div className="text-fg-muted font-body text-[0.625rem] font-[300] ">
                          Room Total :{" "}
                        </div>
                        <BsInfoCircleFill
                          className="text-fg-muted text-[10px]"
                          onClick={() => {
                            dispatch(updateDisplayDetailedBreakupModal(true));
                          }}
                        />
                      </div>

                      <div className="font-medium  text-[12px] leading-[21px]">
                        {Boolean(occupancyPlanRateLoading) ? (
                          <>
                          <CircularProgress size={16} /></>
                        ) : Boolean(calculationResult?.roomTotal) ? (
                          <>
                          {calculationResult?.roomTotal?.toFixed(2)}</>
                        ) : (
                          <>
                          "00"</>
                        )}{" "}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-start">
                    <div className="text-fg-muted  text-[0.625rem] font-[300] ">
                      Discount:
                    </div>
                    <div className="text-fg text-[12px] font-[500] ">
                      {Boolean(calculationResult?.discount)
                        ? calculationResult?.discount?.toFixed(2)
                        : "00"}
                    </div>
                  </div>

                  <div className="flex flex-col items-start">
                    <div className="text-fg-muted text-[0.625rem] font-[300] ">
                      Add-ons
                    </div>
                    <div className="text-fg text-[12px] font-[500]">
                      {Boolean(calculationResult?.addOnsTotal)
                        ? calculationResult?.addOnsTotal?.toFixed(2)
                        : "00"}{" "}
                    </div>
                  </div>

                  <div className="flex flex-col items-start ">
                    <div className="text-fg-muted  text-[0.625rem] font-[300] ">
                      Tax:
                    </div>
                    <div className="text-fg text-[12px] font-[500]">
                      {Boolean(calculationResult?.localTax)
                        ? calculationResult?.localTax?.toFixed(2)
                        : "00"}{" "}
                    </div>
                  </div>

                  <div className="flex flex-col items-start ">
                    <div className="text-fg-muted font-body text-[0.625rem] font-[300] ">
                      Total:
                    </div>
                    <div className="text-fg text-[12px] font-[500]">
                      {Boolean(calculationResult?.total)
                        ? calculationResult?.total?.toFixed(2)
                        : "00"}{" "}
                    </div>
                  </div>
                </div>
              )}{" "}
            </div>

            {!isAllHotelsSelected && !occupancyPlanRateError && (
              <div className=" w-[100%] border-t-[1px] border-brand-border-muted p-3 pr-5 flex justify-end space-x-3">
                <ComplimentaryBookingsButton/>
                <span>{' '}</span>
                <Button
                  type="primary"
                  className="text-[1.125rem] py-5 px-6 uppercase font-[600]"
                  onClick={() => {
                    handleEditRoom();
                  }}
                >
                  Save Changes
                </Button>
              </div>
            )}

            <DetailedBreakupModal />
          </div>
        </div>
      )}
      <MarkComplimentaryRoomsDrawer/>
    </Drawer>
  );
};
export default RoomDrawer;
